import { Injectable } from "@angular/core";
import { Overlay, OverlayConfig } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { SpinnerOverlayComponent } from "./spinner-overlay.component";
import { SpinnerOverlayRef } from "./spinner-overlay.ref";

export interface SpinnerDialogConfig {
	panelClass?: string;
	hasBackdrop?: boolean;
	backdropClass?: string;
}

const DEFAULT_CONFIG: SpinnerDialogConfig = {
	hasBackdrop: true,
	backdropClass: "sdp-dark-backdrop",
	panelClass: "sdp-dark-dialog-panel"
};

@Injectable()
export class SpinnerOverlayService {

	constructor(private overlay: Overlay) { }

	public open(config: SpinnerDialogConfig = {}) {
		const dialogConfig = { ...DEFAULT_CONFIG, ...config };
		const overlayRef = this.createOverlay(dialogConfig);
		const dialogRef = new SpinnerOverlayRef(overlayRef);
		const spinnerOverlay = new ComponentPortal(SpinnerOverlayComponent);
		overlayRef.attach(spinnerOverlay);
		return dialogRef;
	}

	private createOverlay(config: SpinnerDialogConfig) {
		const overlayConfig = this.getOverlayConfig(config);
		return this.overlay.create(overlayConfig);
	}

	private getOverlayConfig(config: SpinnerDialogConfig): OverlayConfig {
		const positionStrategy = this.overlay.position()
			.global()
			.centerHorizontally()
			.centerVertically();

		const overlayConfig = new OverlayConfig({
			hasBackdrop: config.hasBackdrop,
			backdropClass: config.backdropClass,
			panelClass: config.panelClass,
			scrollStrategy: this.overlay.scrollStrategies.block(),
			positionStrategy
		});

		return overlayConfig;
	}
}
